import React from "react";
//Material
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Divider } from "@material-ui/core";

export const BoxTemplate1 = ({
  children,
  title,
  height,
  AddMargin,
  add,
  fontSize = "32px",
  onClickAdd = () => {},
}) => {
  return (
    <>
      <Paper
        elevation={3}
        p={1}
        m={1}
        style={{ height: height, overflowY: "auto", margin: AddMargin }}
      >
        <Box p={1}>
          <Box
            display="flex"
            flexDirection="row"
            p={1}
            style={{ height: "40px" }}
          >
            <h2 style={{ fontWeight: "bold", fontSize }}>{title}</h2>
            <Box flexGrow={1}></Box>
            {add ? <AddCircleOutlineIcon onClick={onClickAdd} /> : null}
          </Box>
          <Box p={1}>{/* <Divider /> */}</Box>
          {children}
        </Box>
      </Paper>
    </>
  );
};

export default BoxTemplate1;
